import React, { useState, useEffect } from "react";
import styles from "./firms.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getFirmsThunk } from "../../services/actions/firms_actions";
import { getCookie } from "../../utils/cookie";
import { getMyFirms, getUser, getCustomer, getRoutes } from "../../services/selectors";
import FirmData from "../collapsed_data_list/payer_data";
import { Link } from "react-router-dom";
import FindUser from "../find_user_or_firm/find_user";
import UserData from "../collapsed_data_list/user_data";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { setMetaTags, getDataFromRoutes } from "../../utils/util_functions";
import SimpleCollapsedContainer from "../collapsed_container/simple_collapsed_container";
import { SET_PORTAL_CONFIRM } from "../../services/actions/portal_actions";
import { TypeConfirm } from "../../utils/constants";
import { TITLE_CONFIRM, TEXT_DELETE_FIRM, FIRMS_IN_PAGE } from "../../utils/constants";
import Paginator from "../paginator/paginator";
import { USER_ROLES } from "../../utils/constants";


const Firms = () => {

  const user = useSelector(getUser);
  const customer = useSelector(getCustomer);

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [currFirms, setCurrFirms] = useState([]);

  const [showUsersList, setShowUsersList] = useState(false);

  const dispatch = useDispatch();
  const firms = useSelector(getMyFirms);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  let accessToken = getCookie('accessToken') || '';
  let refreshToken = getCookie('refreshToken') || '';

  const routes = useSelector(getRoutes);
  const location = useLocation();

  const handleDeleteFirm = (firm, customer) => {
    // нужно useMemo ???
    dispatch({
      type: SET_PORTAL_CONFIRM,
      title: TITLE_CONFIRM,
      text: TEXT_DELETE_FIRM,
      typeConfirm: TypeConfirm.RemoveFirm,
      firm,
      customer
    });
  }

  useEffect(() => {
    if (firms.length > FIRMS_IN_PAGE) {
      setPages(Math.ceil(firms.length / FIRMS_IN_PAGE));
    } else {
      setPages(1);
    }
  }, [firms]);

  useEffect(() => {
    setCurrFirms(firms.slice((page - 1) * FIRMS_IN_PAGE, (page - 1) * FIRMS_IN_PAGE + FIRMS_IN_PAGE))
  }, [page, firms]);

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    const {
      metaTitle, metaDescription, metaKeywords, metaRobots
    } = getDataFromRoutes(location.pathname, routes);
    setMetaTags(
      metaTitle, metaDescription,
      metaKeywords, metaRobots
    )
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (accessToken && refreshToken && customer?.id) {
      dispatch(getFirmsThunk(accessToken, refreshToken, customer?.id));
    }
    // eslint-disable-next-line
  }, [dispatch, customer]);


  return (
    <>
      <p className='fsm3 fw300 gray mb15'>
        Здесь вы можете добавить организацию, если плательщик - юридическое лицо.<br />
        Выбор плательщика производится на этапе оформления заказа.
      </p>
      <p className='fsm3 fw300 gray mb15'>
        Редактирование данных организации доступно только администрации сайта.<br />
        Для изменения данных направьте соответствующее письмо на наш Email.
      </p>
      {(user.role === USER_ROLES.manager || user.role === USER_ROLES.superuser) &&
        <div className={styles.find_user_container}>
          <FindUser showUsersList={showUsersList} setShowUsersList={setShowUsersList} />
          <UserData customer={customer} />
        </div>
      }
      <Link
        to='/profile/add_firm'
        className="button buttonLink"
      >Добавить организацию</Link>

      {firms.length > 0 ?
        <>
          <ul className={styles.list}>
            {currFirms.map(firm =>
              <li key={firm.inn} className={styles.item}>
                <SimpleCollapsedContainer label={firm.name}>
                  <FirmData firm={firm} customer={customer} />
                  {customer.role === USER_ROLES.customer &&
                    <div className="mt20">
                      <button
                        className={`mt20 button button__red`}
                        onClick={() => handleDeleteFirm(firm, customer)}
                      >Удалить организацию</button>
                    </div>
                  }
                </SimpleCollapsedContainer>
              </li>
            )}
          </ul>
          {
            (firms.length > FIRMS_IN_PAGE) &&
            <div className={styles.paginatorWrapper}>
              <Paginator
                page={page}
                setPage={setPage}
                pages={pages}
              />
            </div>
          }
        </>
        :
        <p className='fsm1 mt20'>Организаций пока нет.</p>
      }

    </>
  );
}

export default Firms;
